import { SavedArticlesContext } from "contexts/SavedArticlesContext";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Icon } from "semantic-ui-react";

interface SaveLinkProps {
  as: any;
  targetPage?: string;
  [key: string]: any;
}

export const SaveLink: React.FC<SaveLinkProps> = ({
  children,
  as: Element,
  targetPage: targetPageProp,
  ...props
}) => {
  const { links, addLink, removeLink } = useContext(SavedArticlesContext);
  const [targetPage, setTargetPage] = useState(() => {
    if (typeof window === "undefined") return targetPageProp;
    return targetPageProp ? targetPageProp : window.location.pathname;
  });
  const [isSaved, setSaved] = useState(() => {
    return links.includes(targetPage);
  });

  useEffect(() => {
    setSaved(links.includes(targetPage));
  }, [links, targetPage]);

  // TODO: What was this for?
  // useEffect(() => {
  //   setTargetPage(targetPageProp ? targetPageProp : window.location.href);
  // }, [setTargetPage, targetPageProp]);

  const handleClick = useCallback(() => {
    isSaved ? removeLink(targetPage) : addLink(targetPage);
  }, [addLink, removeLink, isSaved, targetPage]);

  return (
    <Element onClick={handleClick} {...props}>
      {isSaved ? (
        <>
          <Icon name="trash" size="small" />
          Remove
        </>
      ) : (
        <>
          <Icon name="plus" size="small" />
          Save
        </>
      )}
    </Element>
  );
};

export default SaveLink;
